const ITEMS = [
  "Licensed & Insured",
  "Servicing Montgomery/Chester County",
  "Located in Collegeville, PA",
  "Residential & Commercial",
  "Year-Round Service",
  "5-Star Rated on Google",
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="relative overflow-hidden border-y border-white/5 bg-[var(--rr-surface)]"
    >
      <div className="flex w-max rr-marquee py-5">
        {[...ITEMS, ...ITEMS, ...ITEMS].map((it, i) => (
          <div key={`trust-${it}-${i}`} className="flex items-center gap-12 px-8">
            <span className="font-display uppercase tracking-[0.22em] text-sm text-white/80">
              {it}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--rr-secondary)]" />
          </div>
        ))}
      </div>
    </section>
  );
}
